import {useState, useCallback} from 'react';

interface INode {
	value: 'text' | 'password';
	next: INode;
}

const passwordNode: INode = {
	value: 'password',
	next: null,
};

const textNode: INode = {
	value: 'text',
	next: null,
};

passwordNode.next = textNode;
textNode.next = passwordNode;

const usePasswordLoop = () => {
	const [activeNode, setActiveNode] = useState(passwordNode);

	const onToggle = useCallback(() => {
		setActiveNode(activeNode.next);
	}, [activeNode.value]);

	return [activeNode.value, onToggle] as const;
};

export default usePasswordLoop;
